module.exports = __webpack_public_path__ + "img/periodic_crash.2ce483c1.png";